const IS_LOADING = "list/reasons/IS_LOADING";
const IS_PARTIAL_LOADING = "list/reasons/IS_PARTIAL_LOADING";
const IS_ERROR = "list/reasons/IS_ERROR";
const REASONS = "list/reasons/REASONS";
const REASONS_TYPES = "list/reasons/REASONS_TYPES";
const EDIT = "list/reasons/EDIT";

export { IS_LOADING, IS_PARTIAL_LOADING, IS_ERROR, REASONS, REASONS_TYPES, EDIT };
